if (!customElements.get("store-locator-slider")) {
  class StoreLocatorSlider extends HTMLElement {
    constructor() {
      super();
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        window.addEventListener(
          "shopify:section:load",
          this.init.bind(this)
        );
      }
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      this.init();
      window.addEventListener("resize", this.handleResize);
      window.addEventListener("orientationchange", this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("orientationchange", this.handleResize);
    }

    init() {
      this.hasMapLayout = this.classList.contains("store-locator__map-cards");
      this.updateSwiper();
      this.initTooltips();
    }

    initTooltips() {
      const tooltipTriggers = this.querySelectorAll(
        ".tooltip-trigger"
      );

      tooltipTriggers.forEach(trigger => {
        const content = trigger.nextElementSibling;
        if (
          !content ||
          !content.classList.contains("tooltip-content")
        )
          return;
        if (trigger.dataset.tooltipInitialized) return;
        trigger.dataset.tooltipInitialized = "true";

        const closeButton = content.querySelector(".tooltip-drawer__close");

        if (closeButton) {
          closeButton.addEventListener("click", event => {
            event.stopPropagation();
            closeAllTooltips();
          });
        }

        trigger.addEventListener("click", event => {
          event.stopPropagation();
          const wasActive = content.classList.contains("is-active");
          closeAllTooltips();
          if (!wasActive) {
            content.classList.add("is-active");

            const isMobile = typeof DeviceDetector !== 'undefined' ? DeviceDetector.isMobile() : window.innerWidth <= 750;
            if (isMobile) {
              content.originalParent = content.parentElement;
              content.originalNextSibling =
                content.nextElementSibling;
              document.body.appendChild(content);
              document.body.classList.add("tooltip-mobile-open");
            }
          }
        });
      });
      this.querySelectorAll(".tooltip-content").forEach(content => {
        content.addEventListener("click", event =>
          event.stopPropagation()
        );
      });

      const closeAllTooltips = () => {
        document
          .querySelectorAll(".tooltip-content.is-active")
          .forEach(activeContent => {
            activeContent.classList.remove("is-active");

            if (activeContent.originalParent) {
              activeContent.originalParent.insertBefore(
                activeContent,
                activeContent.originalNextSibling
              );
              delete activeContent.originalParent;
              delete activeContent.originalNextSibling;
            }
          });
        document.body.classList.remove("tooltip-mobile-open");
      };

      if (!window.hasTooltipGlobalListener) {
        document.addEventListener("click", closeAllTooltips);
        window.hasTooltipGlobalListener = true;
      }
    }

    handleResize() {
      this.updateSwiper();
    }

    updateSwiper() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      const isDesktop = typeof DeviceDetector !== 'undefined' ? DeviceDetector.isDesktop() : window.innerWidth > 990;
      if (this.hasMapLayout && isDesktop) {
        return;
      }

      const isFade = (this.classList.contains("store-locator__fade-slider") || this.dataset.effect === "fade") && this.dataset.effect !== "slide";
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5000;

      const swiperSettings = {
        slidesPerView: parseInt(this.dataset.slidesPerView) || 1,
        spaceBetween: (isFade || this.dataset.slidesPerView === "1") ? 0 : (parseInt(this.dataset.spaceBetween) || 12),
        loop: !this.hasMapLayout,
      };

      if (isFade) {
        swiperSettings.effect = "fade";
        swiperSettings.fadeEffect = {
          crossFade: true
        };
        swiperSettings.autoplay = {
          delay: autoplaySpeed,
          disableOnInteraction: false
        };
      } else {
        swiperSettings.navigation = {
          nextEl: `.swiper-button--next-${this.dataset.sectionId}`,
          prevEl: `.swiper-button--prev-${this.dataset.sectionId}`
        };
        swiperSettings.pagination = {
          el: `.swiper-pagination-${this.dataset.sectionId}`,
          clickable: true
        };
        if (this.dataset.slidesPerView === "1") {
          swiperSettings.autoplay = {
            delay: autoplaySpeed,
            disableOnInteraction: false
          };
        }
        if (!this.hasMapLayout && this.dataset.slidesPerView !== "1") {
          swiperSettings.breakpoints = {
            1200: {
              slidesPerView: (parseInt(this.dataset.slidesPerView) * 1.02) || 2,
            },
            750: {
              slidesPerView: 2,
            },
            360: {
              slidesPerView: 1.08,
            },
          };
        }
      }

      if (typeof Swiper === 'undefined') {
        document.addEventListener("DOMContentLoaded", () => {
          if (typeof Swiper !== 'undefined' && !this.slider) {
            this.updateSwiper();
          }
        });
        setTimeout(() => {
          if (typeof Swiper !== 'undefined' && !this.slider) {
            this.updateSwiper();
          }
        }, 500);
        return;
      }

      this.slider = new Swiper(this, swiperSettings);


      this.slider.on("slideChange transitionEnd", () => {
        const slides = this.querySelectorAll(
          ".store-locator-card.swiper-slide"
        );
        slides.forEach((slide) => {
          slide.style.display = "block";
        });
      });
    }
  }

  customElements.define("store-locator-slider", StoreLocatorSlider);
}